import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/setMonth/index.js';

var require$$31 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$31 as default };
